/* flow */
import moment from 'moment'
import 'moment/locale/pl'
import 'moment/locale/en-gb'
import { timeSecond, timeMinute, timeHour, timeDay, timeWeek, timeMonth, timeYear } from 'd3-time'
import { round10 } from './utils'
import { locale as enLocale } from './localization/en'
import { locale as plLocale } from './localization/pl'
import type { Lang, Mode } from './App'

export const appClass = 'ac-app'

export const agColors = {
  mercury: '#eaeef0',
  white: '#FFF',
  black: '#000',
  silverChalice: '#A5A5A5'
}

export const chartColors = ["#005f62", "#aec7e8", "#46a6aa", "#ffbb78", "#2ca02c", "#98df8a", "#d62728", "#ff9896", "#9467bd",
"#c5b0d5", "#8c564b", "#c49c94", "#e377c2", "#f7b6d2", "#7f7f7f", "#c7c7c7", "#bcbd22", "#dbdb8d", "#17becf", "#9edae5"]

export const changeColor = (change: number) : string => {
  const n = round10(change, -2)
  let color = 'black'
  if (n > 0.00) {
    color =  'apple'
  } else if (n < 0.00) {
    color = 'mojo'
  }
  return color
}

export const multiFormat = (lang: Lang) => date => {
  const locale = lang === 'pl' ? plLocale : enLocale
  return (timeSecond(date) < date ? locale.format('.%L')
    : timeMinute(date) < date ? locale.format(':%S')
    : timeHour(date) < date ? locale.format('%I:%M')
    : timeDay(date) < date ? locale.format('%I %p')
    : timeMonth(date) < date ? (timeWeek(date) < date ? locale.format('%a %d') : locale.format('%b %d'))
    : timeYear(date) < date ? locale.format('%B')
    : locale.format('%Y'))(date)
}

export const dateFormat = 'YYYY-MM-DD'

export const formatDate = (date: Date, format: string = dateFormat): string => moment(date).format(format)
export const getMoment = (date: string) => moment(date, dateFormat)
export const wrongDateMsg = (date: string): string => `Invalid date format. Got: ${date} Expected: ${dateFormat}`

const validDomains = ['aegonpolska.pl', 'aegon.pl', 'localhost', 'viennapte.pl']

const extractHostname = (url: string): string => {
  let hostname
  //find & remove protocol (http, ftp, etc.) and get hostname
  if (url.indexOf("://") > -1) {
      hostname = url.split('/')[2]
  }
  else {
      hostname = url.split('/')[0]
  }

  //find & remove port number
  hostname = hostname.split(':')[0]
  //find & remove "?"
  hostname = hostname.split('?')[0]
  return hostname
}

export const readUrl = (url: string): string => {
  try {
    if (!url) {
      return ''
    }
    const host = extractHostname(url)
    for(let domain of validDomains) {
      if (host.includes(domain)) {
        return url
      } 
    }
    console.error(`${host} domain of ${url} is invalid.`)
    return ''
  } catch (e) {
    console.error(e)
    return ''
  }
}

const dateLocale = (lang: Lang) => lang === 'pl' ? 'pl-pl' : 'en-gb'

export const setLanguage = (lang: ?Lang): Lang => {
  let lg = lang || navigator.language || 'pl'
  lg = lg.substr(0, 2) === 'en' ? 'en' : 'pl'
  moment.locale(dateLocale(lg))
  return lg
}

export const setDateRange = (dateRange: ?[string, string]): ?[Date, Date] => {
  if (dateRange) {
    let isValid = true
    dateRange.forEach(date => {
      const mom = getMoment(date)
      if (!mom.isValid()) {
        console.error(`Init date error. ${wrongDateMsg(date)}`)
        isValid = false
      }
    })
    return isValid ? [getMoment(dateRange[0]).toDate(), getMoment(dateRange[1]).toDate()] : null
  } else {
    return null
  }
}

const cellInCells = (cellName: string, cells: Array<string>) => !!(cells.findIndex(s => s === cellName) + 1)

const displayCell = (width: number, cellName: string) => {
  if (width < 768) {
    return cellInCells(cellName, ['name', 'val'])
  }
  if (width < 992) {
    return cellInCells(cellName, ['name', 'val', 'd', 'm', 'q', 'y'])
  }
  if (width < 1200) {
    return cellInCells(cellName, ['name', 'val', 'd', 'm', 'q', 'y', 'cat', 'man', 'risk'])
  }
  return true
}

export const cellClassName = (width: number, cellName: string, show: boolean = true) => {
  const first = show ? 'show' : 'hide'
  const second = show ? 'hide' : 'show'
  return displayCell(width, cellName) ? first : second
}

export const headerCellColspan = (width: number) => {
  if (width < 768) {
    return -1
  }
  if (width < 992) {
    return 4
  }
  if (width < 1200) {
    return 6
  }
  return 9
}

export const capitalize = (mode: Mode) => {
  return mode.charAt(0).toUpperCase() + mode.slice(1)
}
  




// WEBPACK FOOTER //
// ./src/globals.js